import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

import { GuestState, StoreKeys, initialState } from './guestStore';

const store = (set) => ({
  ...initialState,
  [StoreKeys.GUEST_DATA]: {},
  [StoreKeys.SET_GUEST_DATA]: (guestData: GuestState['guestData']) =>
    set({ guestData }),
  [StoreKeys.CLEAR_GUEST_DATA]: (defaultValues: GuestState['guestData'] = {}) =>
    set({ guestData: { ...defaultValues } }),
  [StoreKeys.GUEST_PLAN_SELECTOR_DATA]: {},
  [StoreKeys.SET_GUEST_PLAN_SELECTOR_DATA]: (
    guestPlanSelectorData: GuestState['guestPlanSelectorData']
  ) => set({ guestPlanSelectorData: { ...guestPlanSelectorData } }),
  [StoreKeys.CLEAR_GUEST_PLAN_SELECTOR_DATA]: () =>
    set({ guestPlanSelectorData: {} }),
  [StoreKeys.CHOOSE_TYPE]: '',
  [StoreKeys.SET_CHOOSE_TYPE]: (chooseType: string) => set({ chooseType }),
});

const guestStore = persist(store, {
  name: 'guestStore',
  storage: createJSONStorage(() => sessionStorage),
  merge: (persistedState: GuestState, currentState: GuestState) => ({
    ...currentState,
    ...persistedState,
  }),
}) as any;

export const useGuestStore = create(devtools(guestStore));
